import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField
} from "@mui/material";

import { useEffect, useState } from "react";
import useTimezone from "../../helper/useTimezone";
import { setLoader } from "../../store/slices/authSlice";
import { setLoader as setNotificationLoader } from "../../store/slices/notificationSlice";

import { notificationFail } from "../../store/slices/notificationSlice";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { setTenantId } from "../../store/thunk/commonThunk";
import { getLocationLists } from "../../store/thunk/locationThunk";
import { getTenantDropDownList } from "../../store/thunk/tenantThunk";
import { getNotificationRulesThunk, updateNotificationRulesThunk } from "../../store/thunk/thresholdNotificationThunk";
import CustomHeader from "../pageHeader/Index";
import NotificationRulesSkeleton from "../../skeleton/notificationRules/NotificationRulesSkeleton";
import NotificationInfoSkeleton from "../../skeleton/notificationRules/NotificationInfoSkeleton";

export default function NotificationRulesComponent() {
  const dispatch = useAppDispatch();
  const [show, setShow] = useState(false);
  const { themeMode } = useAppSelector((state: any) => state.themeSlice);
  const { tenantDropDownList } = useAppSelector((state) => state.tenantSlice);
  const { notificationData, isLoading } = useAppSelector((state) => state.notificationSlice);
  const [tenant, setTenant] = useState<any>(null);
  const [defaultNotificationData, setDefaultNotificationData] = useState<any>({});
  const [facilityKey, setFacilityKey] = useState<any>("");
  const [submitFlag, setSubmitFlag] = useState<any>(false);
  const { locationList } = useAppSelector((state) => state.locationSlice);
  const items = JSON.parse(localStorage.getItem("tenantId") || "{}");
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const { loading, userData } = useAppSelector(
    (state: any) => state.authReducer
  );
  useTimezone();

  const handleChange = (event: any, value: any) => {
    const request = {
      tenantId: value.tenantCode,
    };
    setFacilityKey("");
    dispatch(getLocationLists(request));
    dispatch(setTenantId(value));
    setTenant(value);
  };

  useEffect(() => {
    if (tenantDropDownList.getTenants) {
      if (items && items.tenantId) {
        setTenant(items);
        dispatch(
          getLocationLists({
            tenantId:
              items && items.tenantId ? items.tenantCode : userData.tenantCode,
          })
        );
      }
    }
  }, [tenantDropDownList]);

  const updateScreenSize = () => {
    setScreenSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };
  useEffect(() => {
    window.addEventListener("resize", updateScreenSize);
    return () => {
      window.removeEventListener("resize", updateScreenSize);
    };
  }, []);

  const handleChangeFilter = (event: any) => {
    dispatch(setNotificationLoader(true));
    setFacilityKey(event.target.value);
  };

  useEffect(() => {
    if (userData.group === "admin") {
      setShow(true);
    }
  }, [userData]);

  useEffect(() => {
    dispatch(getTenantDropDownList({}));
    if (facilityKey !== "") {
      let data = {
        tenantId: getTenantID(),
        facilityKey: facilityKey
      }
      dispatch(setNotificationLoader(true));
      dispatch(getNotificationRulesThunk(data))
        .then((response: any) => {
          dispatch(setNotificationLoader(false));
          let final_data = response?.payload?.getNotificationRules?.notification_data.length === 0
            ? response?.payload?.getNotificationRules?.default_notification :
            response?.payload?.getNotificationRules?.notification_data
          const cleanData = final_data.map((item: any) => ({
            yellow_delay: item.yellow_delay,
            yellow_text: item.yellow_text,
            red_delay: item.red_delay,
            red_text: item.red_text,
            black_delay: item.black_delay,
            black_text: item.black_text,
          }));
          setDefaultNotificationData(cleanData);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
      console.log("notificationData", notificationData);
    }
    else {
      // dispatch(setNotificationLoader(true));
      dispatch(getNotificationRulesThunk({}))
        .then((response: any) => {
          // dispatch(setNotificationLoader(false));
          const cleanData = response?.payload?.getNotificationRules?.default_notification.map((item: any) => ({
            yellow_delay: item.yellow_delay,
            yellow_text: item.yellow_text,
            red_delay: item.red_delay,
            red_text: item.red_text,
            black_delay: item.black_delay,
            black_text: item.black_text,
          }));
          setDefaultNotificationData(cleanData);
        })
        .catch((error) => {
          // dispatch(setNotificationLoader(false));
          console.error("Error:", error);
        });
      console.log("notificationData", notificationData);
    }


  }, [facilityKey]);

  const defaultProps = {
    options: tenantDropDownList?.getTenants
      ? tenantDropDownList?.getTenants.tenants
      : [],
    getOptionLabel: (option: any) => option.tenant_name,
  };



  const handleFieldChange = (key: string, field: string, value: string) => {
    const updatedData = { ...defaultNotificationData };
    if (updatedData[key]) {
      updatedData[key][field] = value;
    }
    setDefaultNotificationData(updatedData);
  };


  const getTenantID = (): string => {
    const tenantData = localStorage?.getItem("tenantId");
    if (tenantData) {
      try {
        const parsedData = JSON.parse(tenantData);
        return parsedData?.tenantId || "";
      } catch (error) {
        return "";
      }
    }
    return "";
  };

  const handleSubmit = () => {
    if (facilityKey) {
      setSubmitFlag(true)
      let defaultNotificationDataFinal = defaultNotificationData[0]
      defaultNotificationDataFinal.facilityKey = facilityKey
      defaultNotificationDataFinal.tenantId = getTenantID()
      dispatch(updateNotificationRulesThunk(defaultNotificationDataFinal));
    }
    else {
      dispatch(notificationFail("Something went wrong!"))
    }
  };

  const handleDefalutNotification = () => {

    if (facilityKey !== "") {
      let data = {
        tenantId: getTenantID(),
        facilityKey: facilityKey
      }
      dispatch(setNotificationLoader(true));
      dispatch(getNotificationRulesThunk(data))
        .then((response: any) => {

          dispatch(setNotificationLoader(false));
          let final_data = response?.payload?.getNotificationRules?.default_notification
          const cleanData = final_data.map((item: any) => ({
            yellow_delay: item.yellow_delay,
            yellow_text: item.yellow_text,
            red_delay: item.red_delay,
            red_text: item.red_text,
            black_delay: item.black_delay,
            black_text: item.black_text,
          }));
          setDefaultNotificationData(cleanData);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }


  return (
    <>
      <Box sx={{hight:"100vh"}}>
        <CustomHeader title="Notification Rules" />
        {loading ? <NotificationRulesSkeleton /> : (
          <Box
            sx={{
              boxShadow:
                "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
              // margin: "10px",
              backgroundColor: "#fff",
              borderRadius: 1,
              mx: 3
            }}
          >
            <Box
              sx={{
                p: 3,
                paddingBottom: "15px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "nowwrap",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <Grid container spacing={2}>
                  {show && (
                    <Grid item xs={12} md={3}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <FormControl
                          variant="outlined"
                          fullWidth
                          className="drpFacility"
                          sx={{
                            marginRight: window?.innerWidth > 950 ? "0.2rem" : "0",
                            marginLeft: window?.innerWidth > 950 ? "0.2rem" : "0",
                          }}
                        >
                          <Autocomplete
                            {...defaultProps}
                            disableClearable
                            id="demo-simple-select"
                            onChange={handleChange}
                            renderTags={() => null}
                            value={tenant}
                            sx={{
                              mb: screenSize?.width > 950 ? 1 : 0,
                              background: themeMode === "dark" ? "#534f4f" : "",
                              borderRadius: 4,
                              color:
                                themeMode === "dark"
                                  ? "white !important"
                                  : "black !important",
                              zIndex: 3,
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Select Tenant" />
                            )}
                          />
                        </FormControl>
                      </Box>
                    </Grid>
                  )}
                  <Grid item xs={12} md={3}>
                    <FormControl fullWidth sx={{ minWidth: 120 }}>
                      <InputLabel id="demo-simple-select-label">
                        Facility
                      </InputLabel>
                      <Select
                        labelId="device-simple-select-label"
                        id="device-simple-select-label"
                        label="Facility"
                        name={"facilityKey"}
                        disabled={tenant != null ? false : true}
                        value={facilityKey}
                        onChange={handleChangeFilter}
                      >
                        {locationList?.getLocations
                          ?.filter((val: any) => val.type === "F")
                          .map((item: any) => (
                            <MenuItem value={item.key}>{item.name}</MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>)}
        {isLoading ? <NotificationInfoSkeleton /> : (<Box>

          {Object.keys(defaultNotificationData).length > 0 && facilityKey !== "" && (
            <Box
              sx={{
                boxShadow:
                  "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                margin: "10px",
                backgroundColor: "#fff",
                borderRadius:1,
                mx:3
              }}
            >
              <Box
                sx={{
                  p: 3,
                  paddingBottom: "15px",
                }}
              >

                {Object.keys(defaultNotificationData).map((key, index) => (
                  <Grid container spacing={2} key={index}>
                    <Grid item xs={4}>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <TextField
                          sx={{ mt: 1, marginBottom: "20px" }}
                          fullWidth
                          id={`yellow-time-${key}`}
                          label="Yellow Time"
                          value={defaultNotificationData[key]?.yellow_delay || ""}
                          variant="outlined"
                          onChange={(e) =>
                            handleFieldChange(key, "yellow_delay", e.target.value)
                          }
                        />

                        <TextField
                          multiline
                          sx={{ mt: 1 }}
                          fullWidth
                          id={`yellow-text-${key}`}
                          label="Yellow Tax"
                          value={defaultNotificationData[key]?.yellow_text || ""}
                          // variant="outlined"
                          onChange={(e) =>
                            handleFieldChange(key, "yellow_text", e.target.value)
                          }
                        />

                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <TextField
                          sx={{ mt: 1, marginBottom: "20px" }}
                          fullWidth
                          id={`red-time-${key}`}
                          label="Red Time"
                          value={defaultNotificationData[key]?.red_delay || ""}
                          onChange={(e) =>
                            handleFieldChange(key, "red_delay", e.target.value)
                          }
                        />
                        <TextField
                          multiline
                          sx={{ mt: 1 }}
                          fullWidth
                          id={`red-text-${key}`}
                          label="Red Text"
                          value={defaultNotificationData[key]?.red_text || ""}
                          onChange={(e) =>
                            handleFieldChange(key, "red_text", e.target.value)
                          }
                        />

                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <TextField
                          sx={{ mt: 1, marginBottom: "20px" }}
                          fullWidth
                          id={`black-time-${key}`}
                          label="Black Time"
                          value={defaultNotificationData[key]?.black_delay || ""}
                          onChange={(e) =>
                            handleFieldChange(key, "black_delay", e.target.value)
                          }
                        />
                        <TextField
                          multiline
                          sx={{ mt: 1 }}
                          fullWidth
                          label="Black Text"
                          id={`black-text-${key}`}
                          placeholder="Black Text"
                          value={defaultNotificationData[key]?.black_text || ""}
                          onChange={(e) =>
                            handleFieldChange(key, "black_text", e.target.value)
                          }
                        />
                      </Box>
                    </Grid>
                    <Box
                      sx={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "end",
                        width: "100%",
                      }}
                    >
                      <Button variant="outlined" style={{ marginRight: "10px" }} onClick={handleDefalutNotification} >
                        Get Defalut Notification
                      </Button>
                      <Button variant="outlined" style={{ backgroundColor: "#123f93", color: "white" }} onClick={handleSubmit} disabled={facilityKey === ""}>
                        Submit
                      </Button>
                    </Box>
                  </Grid>
                ))}
              </Box>
            </Box>
          )}
        </Box>)}
      </Box>
    </>
  );
}
